import GoogleHttp from '../http/google.http';
import AuthHttp from './http/auth.http';
import OrderHttp from './http/order.http';
import ServiceHttp from './http/service.http';
import ShuttleHttp from './http/shuttle.http';
import TripsHttp from './http/trips.http';
import SupplierHttp from './http/supplier.http';
import ProfileHttp from './http/profile.http';
import HolidayHttp from './http/holiday.http';

const google = new GoogleHttp();
const order = new OrderHttp();
const service = new ServiceHttp();
const auth = new AuthHttp();
const shuttle = new ShuttleHttp();
const trips = new TripsHttp();
const supplier = new SupplierHttp();
const profile = new ProfileHttp();
const holiday = new HolidayHttp();

interface HttpHook {
  google: GoogleHttp;
  order: OrderHttp;
  service: ServiceHttp;
  auth: AuthHttp;
  shuttle: ShuttleHttp;
  trips: TripsHttp;
  supplier: SupplierHttp;
  profile: ProfileHttp;
  holiday: HolidayHttp;
}

const httpServices: HttpHook = {
  google,
  order,
  service,
  auth,
  shuttle,
  trips,
  supplier,
  profile,
  holiday,
};

const useHttp = (): HttpHook => {
  return httpServices;
};

export default useHttp;
